var map = {
	"./3d-glasses-1.png": 52575,
	"./3d-glasses-2.png": 14276,
	"./3d-glasses-3.png": 54221,
	"./3d-glasses-4.png": 81714,
	"./action-cam-1.png": 84209,
	"./action-cam-2.png": 59546,
	"./action-cam-3.png": 81123,
	"./action-cam-4.png": 50956,
	"./ecommerce-product-img-1.png": 85993,
	"./ecommerce-product-img-2.png": 55026,
	"./portable-speaker-1.png": 14980,
	"./portable-speaker-2.png": 255,
	"./portable-speaker-3.png": 46454,
	"./speaker-1.png": 42190,
	"./speaker-2.png": 53669,
	"./speaker-3.png": 17756,
	"./watch-1.png": 75000,
	"./watch-2.png": 65843,
	"./watch-3.png": 10634,
	"./watch-4.png": 95301,
	"./watch-card.png": 74955,
	"./white-cam-1.png": 97468,
	"./white-cam-2.png": 21399,
	"./white-cam-3.png": 21902,
	"./white-cam-4.png": 20385,
	"./white-cam-card.png": 96031,
	"./wifi-1.png": 27074,
	"./wifi-2.png": 41081,
	"./wifi-3.png": 25328,
	"./wireless-bluetooth-1.png": 69660,
	"./wireless-bluetooth-2.png": 27767,
	"./wireless-bluetooth-3.png": 98542,
	"./wireless-bluetooth-4.png": 16257,
	"./x-box-image-detail-1.png": 76055,
	"./x-box-image-detail-2.png": 75420,
	"./x-box-image-detail-3.png": 4837,
	"./x-box-image-detail-4.png": 20170,
	"./xbox-1.png": 68278,
	"./xbox-2.png": 83693,
	"./xbox-3.png": 20452,
	"./xbox-4.png": 75259,
	"./xbox-black.png": 22534,
	"./xbox-blue.png": 67835,
	"./xbox-red.png": 94506,
	"./xbox-white.png": 62408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10283;